import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loading } from '../../../components/Loading';

export const AuthCallback = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { handleCognitoAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Procesar la redirección y obtener los datos de autenticación
    const processAuthentication = async () => {
      try {
        // Verificar si hay un código de error en la URL
        console.log('Procesando autenticación...');
        const urlParams = new URLSearchParams(location.search);
        const errorCode = urlParams.get('error');

        if (errorCode) {
          setError(`Error de autenticación: ${errorCode}`);
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          return;
        }

        // Esperar un poco para que las cookies se establezcan correctamente
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Proceder con la autenticación
        console.log('Llamando a handleCognitoAuth...');
        await handleCognitoAuth();
        console.log(
          'Autenticación completada, redirigiendo a bandejaTrabajo...'
        );
        navigate('/bandejaTrabajo', { replace: true });
      } catch (error) {
        console.error('Error al procesar la autenticación:', error);
        setError(
          'Ocurrió un error durante el proceso de autenticación. Redirigiendo al inicio de sesión...'
        );
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    };

    processAuthentication();
  }, [handleCognitoAuth, location.search, navigate]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      {isLoading && <Loading />}
      {isLoading && (
        <p className="mt-4 text-center">
          Procesando la autenticación, por favor espere...
        </p>
      )}
      {error && (
        <div className="alert alert-danger mt-4">{error}</div>
      )}
    </div>
  );
};
